import { VendorCTATypes } from '../types/index';

export const getEnabledVendorCTAs = (content: VendorCTATypes) => {
  const { vendorCtaGroup } = content;

  const enabledCTAs = {
    vendorCtaGroup: vendorCtaGroup?.filter((cta) => cta.isVendorCtaEnabled),
  };

  return enabledCTAs;
};
